// API Keys - loaded from environment at build time
export const API_KEYS = {
  ANTHROPIC: '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',
  OPENAI: '',
  MESHY: '',
  TRIPO3D: '',
}
